module.exports = __webpack_public_path__ + "img/google_app.db9b21a1.png";